import { render, staticRenderFns } from "./VNavigationSidebar.vue?vue&type=template&id=ff83a96e&scoped=true&"
import script from "./VNavigationSidebar.vue?vue&type=script&lang=js&"
export * from "./VNavigationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./VNavigationSidebar.vue?vue&type=style&index=0&id=ff83a96e&scoped=true&lang=scss&"
import style1 from "./VNavigationSidebar.vue?vue&type=style&index=1&id=ff83a96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff83a96e",
  null
  
)

export default component.exports